import { StarBorderOutlined, StarOutlineRounded } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import { Product } from '../../Models/Products';
import ProductCard from '../ProductCard/ProductCard';
import { Link } from 'react-router-dom';


// export interface Product {
//     productId: number;
//     productName: string;
//     description: string;
//     seller_type: string;
//     seller_id: number;
//     base_price: string;
//     currency: string;
//     is_active: boolean;
//     created_by: number;
//     updated_by: number | null;
//     created_at: string;
//     updated_at: string;

//     category: Category;
//     gender: Gender;
//     variants: Variant[];
//     media: ProductMedia[];
//     reviews: Review[];
// }

// export interface Category {
//     categoryId: number;
//     categoryName: string;
//     categoryIcon: string;
//     slug: string;
//     level: number;
//     is_active: boolean;
//     sort_order: number;
//     type: string;
//     created_at: string;
//     updated_at: string;
//     created_by: number;
//     updated_by: number;
// }

// export interface Gender {
//     genderId: number;
//     name: string;
//     is_active: boolean;
//     created_at: string;
//     updated_at: string;
// }

// export interface Variant {
//     variantId: number;
//     name: string;
//     sku: string;
//     price: string;
//     stock: number;
//     created_by: number;
//     updated_by: number | null;
//     created_at: string;
//     updated_at: string;

//     variantImages: VariantImage[];
//     color: Color;
//     size: Size;
// }

// export interface VariantImage {
//     variantImageId: number;
//     image_url: string;
//     alt_text: string;
//     is_active: boolean;
//     created_by: number;
//     updated_by: number | null;
//     created_at: string;
//     updated_at: string;
// }

// export interface Color {
//     colorId: number;
//     name: string;
//     hex_code: string;
//     is_active: boolean;
//     created_at: string;
//     updated_at: string;
// }

// export interface Size {
//     sizeId: number;
//     name: string;
//     is_active: boolean;
//     created_at: string;
//     updated_at: string;
// }

// export interface ProductMedia {
//     mediaId: number;
//     media_url: string;
//     media_type: string;
//     sort_order: number;
//     is_thumbnail: boolean;
//     alt_text: string;
//     video_thumbnail: string | null;
//     created_by: number;
//     updated_by: number | null;
//     created_at: string;
//     updated_at: string;
// }

// export interface Review {
//     [key: string]: any;
// }


interface Slider {
    slides: Product[]
}
function Slider({ slides }: Slider) {
    return (
        <Box
            sx={{
                width: "100%",
                overflowX: "auto",
                overflowY: "hidden",
                whiteSpace: "nowrap",
                scrollbarWidth: "none",
            }}
        >
            <Grid
                container
                spacing={3}
                sx={{
                    width: "max-content",
                    flexWrap: "nowrap",
                }}
            >
                {slides?.map((item: Product, index: number) => (
                        <ProductCard product={item} />
                    // <Grid
                    //     key={index}
                    //     size="auto"
                    //     className="border-10 overflow-hidden  d-flex flex-column"
                    //     sx={{
                    //         width: {
                    //             xs: "250px",
                    //             md: "250px",
                    //             lg: "300px",
                    //         },
                    //         height: {
                    //             xs: "250px",
                    //             md: "350px",
                    //             lg: "400px",
                    //         },
                    //         flexShrink: 0,
                    //     }}
                    // >
                    //     <Box
                    //         sx={{
                    //             flexGrow: 1,
                    //             minHeight: 0,
                    //             overflow: "hidden",
                    //         }}
                    //     >
                    //         <Box
                    //             component="img"
                    //             className='border-10 bg-light'
                    //             src={item?.media?.[0]?.media_url}
                    //             alt={item?.productName}
                    //             sx={{
                    //                 width: "100%",
                    //                 height: "100%",
                    //                 objectFit: "cover",
                    //             }}
                    //         />
                    //     </Box>

                    //     <Typography className="text-white fw-bold fs-18 mt-2">
                    //         {item?.productName}
                    //     </Typography>

                    //     <Box className="d-flex align-items-center gap-1">
                    //         {[...Array(5)].map((_, index) =>
                    //             index < (item?.reviews?.length || 0) ? (
                    //                 <StarOutlineRounded
                    //                     key={index}
                    //                     sx={{ color: "#FFD700", fontSize: 20 }}
                    //                 />
                    //             ) : (
                    //                 <StarBorderOutlined
                    //                     key={index}
                    //                     sx={{ color: "#808080", fontSize: 20 }}
                    //                 />
                    //             )
                    //         )}

                    //         <Typography className="text-white fs-12" gutterBottom>
                    //             {item?.reviews?.length || 0}
                    //         </Typography>
                    //     </Box>

                    //     <Typography className='text-white fw-bold fs-20'>$ {item?.base_price}</Typography>
                    // </Grid>
                ))}
            </Grid>
        </Box>
    )
}

export default Slider
